
const isObject = v => v !== null && typeof v === 'object' && !(v instanceof File)
const isArray = v => Array.isArray(v)

const arrayToFormData = (namespace, value, callback) => {
  const newNamespace = `${namespace}[]`

  value.forEach(v => {
    if (isArray(v))
     arrayToFormData(newNamespace, v, callback)
    else if (isObject(v))
      objectToFormData(newNamespace, v, callback)
    else
      callback(newNamespace, v)
  })
}

const objectToFormData = (namespace, object, callback) => {
  Object.entries(object).forEach(([key, value]) => {
    const newNamespace = `${namespace}[${key}]`
    if (isArray(value))
      arrayToFormData(newNamespace, value, callback)
    else if (isObject(value))
      objectToFormData(newNamespace, value, callback)
    else
      callback(newNamespace, value)
  })
}

export default class CustomFormData extends FormData {
  append(name, value) {
    const method = (name, value) => super.append(name, value)

    if (isArray(value)) {
      arrayToFormData(name, value, method)
    } else if (isObject(value)) {
      objectToFormData(name, value, method)
    } else
        method(name, value)
  }
}